import { matchPath } from 'react-router-dom'
import axios from 'axios'
import humps from 'humps'
import qs from 'qs'

import { getBaseURL } from './env'
import * as service from 'service'
import history from 'routes/history'
import routes from 'routes/routes'

const isFormData = data => data instanceof FormData

const matchRouteSubscribe = () =>
  matchPath(history.location.pathname, {
    path: routes.subscribe.main,
  })

const getAuthToken = isRouteSubscribe =>
  isRouteSubscribe
    ? service.storage.getRecurrenceAuthTokenCustomer()
    : service.storage.getRecurrenceAuthToken()

export const create = (projectTag, treatError = true) => {
  const api = axios.create({ baseURL: getBaseURL(projectTag) })

  api.interceptors.request.use(reqConfig => {
    const isRouteSubscribe = !!matchRouteSubscribe()
    const authToken = getAuthToken(isRouteSubscribe)

    if (authToken) {
      reqConfig.headers.Authorization = `${authToken}`
    }

    reqConfig.data = isFormData(reqConfig.data)
      ? reqConfig.data
      : humps.decamelizeKeys(reqConfig.data)

    reqConfig.params = humps.decamelizeKeys(reqConfig.params)

    reqConfig.paramsSerializer = params => {
      return qs.stringify(params, {
        arrayFormat: 'brackets',
        encode: false,
      })
    }

    return reqConfig
  })

  api.interceptors.response.use(
    resp => {
      if (resp.headers['content-type'].includes('application/json')) {
        return humps.camelizeKeys(resp)
      }

      return resp
    },
    error => {
      const isRouteSubscribe = !!matchRouteSubscribe()

      if (
        error.response.status === 403 &&
        error.response.data.error.message === 'Usuário Inativo'
      ) {
        service.storage.removeRecurrenceAuthToken()
        history.push(routes.root, { clearAuth: true })

        return Promise.reject(humps.camelizeKeys(error))
      }

      if (treatError && error.response.status === 401) {
        if (isRouteSubscribe) {
          service.storage.removeRecurrenceAuthTokenCustomer()
          return Promise.reject(humps.camelizeKeys(error))
        }

        service.storage.removeRecurrenceAuthToken()
        history.push(routes.root, { clearAuth: true })

        return Promise.reject(humps.camelizeKeys(error))
      }

      return Promise.reject(humps.camelizeKeys(error))
    },
  )

  return api
}

export default { create }
